import * as Sentry from '@sentry/browser'
import type { ErrorInfo } from 'react'
import { defaultConfig } from '@/config'

export function reportErrorBoundaryToSentry(
  error: Error,
  info: ErrorInfo
): void {
  if (defaultConfig().envMode !== 'production') return
  Sentry.captureException(error, {
    contexts: { react: { componentStack: info.componentStack } },
  })
}
